import React from 'react'
import { Link } from 'react-router-dom'
// import PropTypes from 'prop-types'

const Navbar=()=> {
    return (
      <nav className="navbar fixed-top navbar-expand-lg bg-body-light bg-dark">
      <div className="container-fluid">
    <Link style={{color:'white'}} className="navbar-brand" to="/">News Monkey</Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link style={{color:'white'}} className="nav-link"  aria-current="page" to="/">Home</Link>
        </li>
        <li className="nav-item">
          <Link style={{color:'white'}} className="nav-link" to="/bussiness">Business</Link>
        </li>
        <li className="nav-item">
          <Link style={{color:'white'}} className="nav-link" to="/entertainment">Entertainment</Link>
        </li>
        <li className="nav-item">   
          <Link style={{color:'white'}} className="nav-link" to="/general">General</Link>
        </li>
        <li className="nav-item">
          <Link style={{color:'white'}} className="nav-link" to="/health">Health</Link>
        </li>
        <li className="nav-item">
          <Link style={{color:'white'}} className="nav-link" to="/science">Science</Link>
        </li>
        <li className="nav-item">
          <Link style={{color:'white'}} className="nav-link" to="/sports">sports</Link>
        </li>
        <li className="nav-item">
          <Link style={{color:'white'}} className="nav-link" to="/technology">technology</Link>
        </li>
      </ul>
      
    </div>
  </div>
</nav>
    )
  }


export default Navbar
